import { FC, HTMLAttributes, forwardRef } from "react"
import "./index.scss"

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  className?: string
  triangleTopPosLeft?: string | null
  triangleBottomPosLeft?: string | null
  children?: React.ReactNode
  revertTopLeftTriangle?: boolean
  revertBottomLeftTriangle?: boolean
}

const Container = forwardRef<HTMLDivElement, ContainerProps>(
  (
    {
      className,
      triangleTopPosLeft = null,
      triangleBottomPosLeft = null,
      children,
      revertBottomLeftTriangle,
      revertTopLeftTriangle,
      ...rest
    }: ContainerProps,
    ref
  ) => {
    return (
      <div ref={ref} className={"container " + className} {...rest}>
        {triangleTopPosLeft && (
          <Triangle
            revert={revertTopLeftTriangle}
            position="top"
            leftValue={triangleTopPosLeft}
          />
        )}
        {children || ""}
        {triangleBottomPosLeft && (
          <Triangle
            revert={revertBottomLeftTriangle}
            position="bottom"
            leftValue={triangleBottomPosLeft}
          />
        )}
      </div>
    )
  }
)

interface TriangleProps {
  position: string
  leftValue: string
  revert?: boolean
}

export const Triangle: FC<TriangleProps> = ({
  position,
  leftValue,
  revert
}) => {
  return (
    <div
      className={"triangle " + position}
      style={{
        left: leftValue,
        transform: revert
          ? position === "top"
            ? "scaleX(1)"
            : "scaleX(-1)"
          : undefined
      }}
    ></div>
  )
}

export default Container
